module.exports = __webpack_public_path__ + "media/images/guideline/A02-2935930269d889cc83575650100c2307.jpg";